import PublicApi from '@/service/PublicApi';

let contextRequest = null;

export async function loadRuntimeContext() {
  if (!contextRequest) {
    contextRequest = PublicApi()
      .get('/tenant/context')
      .then(({ data }) => data)
      .catch((error) => {
        contextRequest = null;
        throw error;
      });
  }

  return contextRequest;
}
